import * as React from 'react';
import { ThemeContext } from '../app';

export type ComponentFunction<T> = {
    (props: T): JSX.Element
}

// This function takes a component...
export function withTheme<T = any>(Component): ComponentFunction<T> {
    // ...and returns another component...
    return (props: T): JSX.Element => {
        // ... and renders the wrapped component with the context theme!
        // Notice that we pass through any additional props as well
        return (
            <ThemeContext.Consumer>
                {theme => <Component
                    {...props}
                    theme={theme.theme}
                    classification={theme.classification}
                />}
            </ThemeContext.Consumer>
        );
    };
}